import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  NgZone,
} from "@angular/core";
import { RenderedService } from "../../rendered.service";
import { TinyMCEOptions } from "@app/shared/tinymce_options";
import cloneDeep from 'lodash/cloneDeep';
import { getTinymce } from "@scaffold/tinymce/TinyMCE";
import {
  CommentingService,
  CommentItem,
} from "@scaffold/services/commenting.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { LtiService } from "@services/lti.service";
import { HtmldocModalComponent } from "@scaffold/dialogs/htmldoc-modal/htmldoc-modal.component";
import { DomSanitizer } from "@angular/platform-browser";
import { NbDialogService, NbDialogRef } from "@nebular/theme";
import { ScaffoldSidebarService } from "@services/scaffold-sidebar.service";
import { CommentSidebarComponent } from "@app/commenting/comment-sidebar/comment-sidebar.component";
import { Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";
import { ItemsService } from "@scaffold/services/items.service";

@Component({
  selector: "scaffold-input",
  templateUrl: "./input.component.html",
  styleUrls: ["../../rendered.component.scss", "./input.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  @Output() change = new EventEmitter<any>();
  public destroy$: Subject<boolean> = new Subject<boolean>();
  public inputValue$ = new Subject();
  public isPristine :boolean = true
  error;
  active = true;
  editor_options;
  isEditorActive = false;
  private _rte_value;
  private sent: string;;
  set rte_value(v) {
    this._rte_value = v;
    this.editDirty(null, null, v);
  }
  get rte_value() {
    return this._rte_value;
  }
  debounce;
  tools: any = [];
  dialogRef: NbDialogRef<HtmldocModalComponent>;
  // tslint:disable-next-line:max-line-length
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    public editor: TinyMCEOptions,
    private commentor: CommentingService,
    private _zone: NgZone,
    private LTIService: LtiService,
    private domSanitizer: DomSanitizer,
    private itemsService:ItemsService,
    public dialog: NbDialogService,
    private commentSidebar: ScaffoldSidebarService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {

    this.itemsService.hasAttemptedSave.pipe(takeUntil(this.destroy$)).subscribe(hasAttemptedSave=>{
      // mark as not pristine if a save has been attempted
      this.isPristine = !hasAttemptedSave;
      this.cdr.detectChanges();
    })
    
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.markForCheck();
      });
    /* this.LTIService.getToolList().pipe(take(1)).subscribe(tools => {
       if (tools.id) {
         this.tools.push(tools);
       } else {
         this.tools = tools.listItems;
       }*/

    this.editor_options = cloneDeep(this.editor.options);
    if (this.item.hide_editor_ui) {
      this.editor_options.menubar = false;
      this.editor_options.toolbar = false;
    }
    if (this.item.block_editor) {
      this.editor_options.inline = !this.item.block_editor;
    } else this.editor_options.inline = true;
    this.editor_options.setup = this.setup.bind(this);
    this.cdr.markForCheck();
    // });
    this.inputValue$
      .pipe(takeUntil(this.destroy$), debounceTime(500))
      .subscribe((value) => this.updateFromElement(value));
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.active = false;
    this.editor_options = cloneDeep(this.editor.options);
    if (this.item.hide_editor_ui) {
      this.editor_options.menubar = false;
      this.editor_options.toolbar = false;
    }
    if (this.debounce) {
      clearTimeout(this.debounce);
      this.debounce = null;
      this.change.emit({ value: this.value, error: this.error });
    }
  }

  setup(editor: any) {
    console.log("SETUP");
    const $this = this;
    const tool_buttons = [];
    console.log($this.tools);
    this.tools.forEach((tool) => {
      console.log(tool);
      if (tool.data.location) {
        const button = tool.data.location.find(
          (t) => t.location_type === "editor_button"
        );
        tool_buttons.push({
          text: tool.title,
          icon: tool.data.icon || false,
          onclick: function () {
            $this._zone.run(() => {
              $this.launch.call($this, tool, button);
            });
            // editor.insertContent('&nbsp;<strong>Menu item 1 text inserted here!</strong>&nbsp;');
          },
        });
      }
    });
    if (tool_buttons.length > 0) {
      editor.addButton("external", {
        type: "menubutton",
        text: "External Tools",
        icon: false,
        menu: tool_buttons,
      });
    }
    console.log(editor);
    editor.on("ObjectResized", function (e) {
      if (e.target.nodeName == "IMG") {
        var selectedImage = editor.selection.getNode();
        console.log(selectedImage);
        editor.dom.setStyle(selectedImage, "width", e.width);
        editor.dom.setStyle(selectedImage, "height", null);

        selectedImage.removeAttribute("width");
        selectedImage.removeAttribute("height");
      }
    });
    editor.on("ObjectSelected", function (e) {
      if (e.target.nodeName == "IMG") {
        let width = e.target.getAttribute("width");
        let height = e.target.getAttribute("height");
        let selectedImage: Element = editor.selection.getNode();
        console.log(width, height, selectedImage);
        if (width && width.length > 0) {
          editor.dom.setStyle(selectedImage, "width", width + "px");
          selectedImage.removeAttribute("width");
        }
        if (height && height.length > 0) {
          editor.dom.setStyle(selectedImage, "height", height + "px");
          selectedImage.removeAttribute("height");
        }
      }
    });
    editor.on("NodeChange", function (ed, cm, de) {
      if (myButton) {
        myButton.disabled(editor.selection.getContent().length === 0);
      }
    });
    let myButton = null;
    editor.addButton("wrapselection", {
      title: "Comment",
      icon: "bubble",
      onPostRender: function () {
        myButton = this;
      },
      onclick: function () {
        // console.log('Selection: ' + editor.selection.getNode());
        const content = editor.getContent();

        const win = editor.windowManager.open({
          title: "Comment",
          body: {
            type: "textbox",
            name: "comment",
            multiline: true,
            minWidth: editor.getParam("code_dialog_width", 400),
            minHeight: editor.getParam(
              "code_dialog_height",
              Math.min(getTinymce().DOM.getViewPort().h - 200, 500)
            ),
            spellcheck: false,
            style: "direction: ltr; text-align: left",
          },
          onSubmit: function (e) {
            const selection = editor.selection.getContent();
            const id = "comment-selection-" + Math.floor(Math.random() * 10000);
            editor.undoManager.transact(function () {
              editor.insertContent(
                "<span class='comment-sellection' id='" +
                  id +
                  "'>" +
                  editor.selection.getContent() +
                  "</span>"
              );
            });
            console.log($this);
            $this._zone.run(() => {
              let config: any = {
                context: {
                  item: $this.item.name,
                  info: $this.info,
                  label: $this.item.label || $this.item.name,
                },
              };
              let _sidebar = $this.commentSidebar.open(
                CommentSidebarComponent,
                config
              );
              let comment: CommentItem = new CommentItem();
              comment = {
                ...comment,
                ...{
                  text: e.data.comment,
                  selection: selection,
                  selection_id: id,
                },
              };
              $this.editDirty($this.data, $this.item.name, editor.getContent());
              $this.commentor.addComment(comment, null).subscribe((c) => {
                console.log(c);
                if (c) {
                } else {
                  editor.$("#" + id).replaceWith(selection);
                }
              });
            });
            editor.focus();
            editor.selection.setCursorLocation();
            editor.nodeChanged();
          },
        });
      },
    });
    editor.addMenuItem("formatScrub", {
      text: "Remove Layout",
      context: "format",
      onclick: function () {
        const html = editor.getContent();
        const item = document.createElement("div");
        item.innerHTML = html;
        const ids = item.querySelectorAll("div");
        ids.forEach((i) => unwrap(i));
        const spans = item.querySelectorAll("span");
        spans.forEach((i) => unwrap(i));
        item
          .querySelectorAll("[style]")
          .forEach((el) => el.removeAttribute("style"));
        editor.undoManager.add();
        editor.setContent(item.innerHTML);
        editor.focus();
        editor.nodeChanged();
        function unwrap(el) {
          // get the element's parent node
          const parent = el.parentNode;

          // move all children out of the element
          while (el.firstChild) {
            parent.insertBefore(el.firstChild, el);
          }

          // remove the empty element
          parent.removeChild(el);
        }
      },
    });
  }

  editorActive(status) {
    this.isEditorActive = status;
    if (this.debounce) {
      clearTimeout(this.debounce);
      this.debounce = null;
      this.change.emit({ value: this.value, error: this.error });
    }
    //console.log(status);
    this.cdr.detectChanges();
  }

  updateField(data){
    this.inputValue$.next(data)
  }

  updateFromElement(data, eventKey?) {
    this.isPristine = false
    let error;
    // console.log(data)
    let value = data.target.value;
    if (this.item.required&&!value ||data.target.validity.valid === false&&(this.item.validate)) {
      error = this.item.invalid || data.target.validationMessage;
      this.item.notvalid = true;
    } else {
      this.item.notvalid = false;
    }
    this.cdr.detectChanges();
    if (typeof value === "string" && value.length === 0) {
      value = null;
    }
    if (this.item.input_type === "number") {
      // if (error) {
      //   if (data.target.validity.rangeOverflow) {
      //     this.item.value = data.target.max;
      //     value = data.target.max;
      //     error = undefined
      //   }
      //   if (data.target.validity.rangeUnderflow) {
      //     this.item.value = data.target.min;
      //     value = data.target.min;
      //     error = undefined
      //   }
      // }
    }
    // console.log(value, eventKey || 'value');
    this.editDirty(this.data, this.item.name, value, error);
  }
  editDirty(obj, param, value, error?) {
    this.value = value;
    this.error = error;
    if (this.debounce) {
      //   console.log("Clear Debounce")
      clearTimeout(this.debounce);
    }
    if (this.active) {
      this.debounce = setTimeout(() => {
        //  console.log("after debounce")
        if (this.active) {
          this.change.emit({ value: this.value, error: this.error });
          this.debounce = null;
        }
      }, 300);
    }
  }

  launch(tool, button?) {
    const info = this.info;
    //  this.src = "https://tuc6cdlir6.execute-api.us-east-2.amazonaws.com/dev/"
    const settings: any = {
      context: {
        data: {
          tool: tool,
          button: button,
          info: info,
          type: "content",
        },
      },
    };
    this.dialogRef = this.dialog.open(HtmldocModalComponent, settings);
  }

  update() {
    if (this._rte_value != this._value && !this.isEditorActive) {
      this._rte_value = this._value;
      this.cdr.markForCheck();
    }
  }

  log(e) {
    console.log(e);
  }
}
